var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashcan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0625 6H29.125L26.2031 2.21875C25.5156 1.27344 24.0547 0.5 22.9375 0.5H16.0625C14.8594 0.5 13.3984 1.27344 12.7109 2.21875L9.875 6H0.9375C0.507812 6 0.25 6.34375 0.25 6.6875V8.0625C0.25 8.49219 0.507812 8.75 0.9375 8.75H2.48438L5.40625 40.8047C5.57812 42.8672 7.38281 44.5 9.44531 44.5H29.4688C31.5312 44.5 33.3359 42.8672 33.5078 40.8047L36.4297 8.75H38.0625C38.4062 8.75 38.75 8.49219 38.75 8.0625V6.6875C38.75 6.34375 38.4062 6 38.0625 6ZM14.9453 3.85156C15.1172 3.50781 15.6328 3.33594 16.0625 3.25H22.9375C23.2812 3.33594 23.7969 3.50781 23.9688 3.85156L25.6875 6H13.3125L14.9453 3.85156ZM30.8438 40.5469C30.7578 41.2344 30.1562 41.75 29.4688 41.75H9.44531C8.75781 41.75 8.15625 41.2344 8.15625 40.5469L5.32031 8.75H33.6797L30.8438 40.5469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.e85d2f766b103bf2b18b669a0cbb3035.svg";
export { ForwardRef as ReactComponent };